package pl.decks.chartjs.radar.dataset

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.style.BorderCapStyle
import pl.decks.chartjs.style.BorderJoinStyle

data class LineHoverProperties(
    val backgroundColor: JSScriptable<ChartColor>? = null,
    val borderColor: JSScriptable<ChartColor>? = null,
    val borderWidth: JSScriptable<Int>? = null,
    val borderCapStyle: JSScriptable<BorderCapStyle>? = null,
    val borderJoinStyle: JSScriptable<BorderJoinStyle>? = null,
    val borderDash: JSScriptable<List<Int>>? = null,
    val borderDashOffset: JSScriptable<Float>? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        if (backgroundColor != null) this.backgroundColor = backgroundColor.toChartJs { it.toChartJs() }
        if (borderColor != null) this.borderColor = borderColor.toChartJs { it.toChartJs() }
        if (borderWidth != null) this.borderWidth = borderWidth.toChartJs { it.asDynamic() }
        if (borderCapStyle != null) this.borderCapStyle = borderCapStyle.toChartJs { it.toChartJs() }
        if (borderJoinStyle != null) this.borderJoinStyle = borderJoinStyle.toChartJs { it.toChartJs() }
        if (borderDash != null) this.borderDash = borderDash.toChartJs { it.toTypedArray().asDynamic() }
        if (borderDashOffset != null) this.borderDashOffset = borderDashOffset.toChartJs { it.asDynamic() }
    }
}
